export default __webpack_public_path__ + "engine/assets/aWDAfHF.png";